export const MessageConstantTableHeaders = [
  "message-constant-from",
  "message-constant-to",
  "modify",
  "delete",
];
